import request from '@/plugins/axios'

//检索图集
export function searchAtlas(params) {
  return request({
    url: '/search/searchAtlas',
    method: 'get',
    params
  })
}



//检索图片
export function searchPicture(params) {
  return request({
    url: '/search/searchPicture',
    method: 'get',
    params
  })
}



//检索图片---高级
export function advSearchPicture(params) {
  return request({
    url: '/search/advSearchPicture',
    method: 'get',
    params
  })
}



//检索视频
export function searchVideo(params) {
  return request({
    url: '/search/searchVideo',
    method: 'get',
    params
  })
}


//检索视频---高级
export function advSearchVideo(params) {
  return request({
    url: '/search/advSearchVideo',
    method: 'get',
    params
  })
}

//检索文稿---高级
export function advSearchDocument(params) {
  return request({
    url: '/search/advSearchDocument',
    method: 'get',
    params
  })
}